<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <navigation :list="tags" :active-value="activeTag" variety="segmented" @active:updated="updateActiveTag" />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <portlet class="news_content_area">
            <div class="title">
              全部最新消息
            </div>
            <ul class="news_list">
              <news-meta v-for="news in allNewsGetter" :key="news.news_id" :news-id="news.news_id"
                :headline="news.news_topic" :published-date="news.news_published_at" :tag-color="news.news_type_color"
                :tag-text="news.news_type_text" :is-pinned="news.news_is_pinned" />
            </ul>
            <bootstrap-pagination v-if="pageGetter.page_total > 1" :total-page-number="pageGetter.page_total"
              @number:updated="updateNewsPage" />
          </portlet>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import NewsMeta from '~components/pages/news/NewsMeta'
import BootstrapPagination from '~bootstrap/Pagination'
import Navigation from '~components/common/Navigation'
import Portlet from '~components/common/Portlet'
export default {
  name: 'NewsIndexContent',
  components: {
    NewsMeta,
    BootstrapPagination,
    Navigation,
    Portlet
  },
  data() {
    return {
      activeTag: this.$route.query.tag || '全部',
      tags: ['全部', '實習資訊', '徵才快報', '活動公告', '一般訊息']
    }
  },
  computed: {
    ...mapGetters('pages/news', [
      'allNewsGetter',
      'pageGetter'
    ]),
    activeNewsType() {
      return this.getText.indexOf(this.activeTag)
    }
  },
  mounted() {
    this.updateTagsData(this.tags.indexOf(this.activeTag));
  },
  methods: {
    ...mapActions('pages/news', [
      'getNewsAll'
    ]),
    updateActiveTag(tag) {
      this.activeTag = tag
      this.$router.push({
        path: '/news',
        query: {
          tag: tag
        }
      })
      this.updateTagsData(this.tags.indexOf(tag))
    },
    updateTagsData(type) {
      this.getNewsAll({
        type: type || null,
        page: 1
      })
    },
    updateNewsPage(page) {
      const type = this.tags.indexOf(this.activeTag) || null
      this.getNewsAll({
        type: type || null,
        page
      })
    }
  }
}
</script>
